import React, { useState } from "react";
import "./influencer-database-home.scss";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { AdminPageHead, AdminTabs } from "../admin-dashboard/components/AdminPageHead";
import InstagramIcon from "../../../../components/icons/instagram-icon";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { AddInfluencerIG } from "./add-Influencer-ig";
import { AddInfluencerYT } from "./add-Influencer-yt";
import { ExcelFileInput } from "../../../../components/excel-file-upload";



export const InfluencerDatabaseHome: React.FC = () => {
  const [value, setValue] = useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setShowDetail(false);
    setValue(newValue);
    setExcelData([]);
  };
  const [showDetail, setShowDetail] = React.useState(false);
  const [showExcelUpload, setShowExcelUpload] = React.useState(false);
  const [showPopup, setShowPopup] = React.useState(false);
  const [excelData, setExcelData] = useState<any[]>([]);

  const handleExcelData = (data: any[]) => {
    setExcelData(data);
  }

  const clearExcelData = () => {
    setExcelData([]); // Clear the Excel data after successful processing
  };

  const handleUpload = () => {
    setShowExcelUpload(true)
    setShowPopup(true)
    setTimeout(() => setShowPopup(false), 0);
  }

  // const fileToDownload = value === "1" ? instagramSheet : youtubeSheet;


  return (
    <section className="inf-database-section influencer-database-home">
      <AdminPageHead
        title="Influencer Database"
        subtitle="Creators added by hand or from an Excel sheet, with their rates and past campaigns."
        actions={<>
          <button
            className={`btn ${showDetail ? 'btn-primary' : 'btn-outline-primary'} btn-sm`}
            onClick={() => setShowDetail(prevState => !prevState)}
          >
            {showDetail ? 'Hide Influencer Form' : 'Add Influencer Details'}
          </button>
          <button className="btn btn-primary btn-sm" onClick={handleUpload}>
            {`Upload ${value === "1" ? 'Instagram' : 'YouTube'} Excel sheet`}
          </button>
          <a href={""} className="brd-link" download>
            {`Download ${value === "1" ? 'Instagram' : 'YouTube'} Excel sheet`}
          </a>
        </>}
      />

      <TabContext value={value}>
        <AdminTabs
          current={value}
          onChange={(v) => handleChange({} as React.SyntheticEvent, v)}
          tabs={[
            { value: "1", label: "Instagram", icon: <InstagramIcon width={18} /> },
            { value: "2", label: "YouTube", icon: <YouTubeIcon style={{ color: "red", fontSize: "20px" }} /> },
          ]}
        />
        <TabPanel value="1" sx={{ p: 0 }}>
          {value === "1" && (<AddInfluencerIG showAddInfluencer={showDetail} excelData={excelData} clearExcelData={clearExcelData} />)}
        </TabPanel>
        <TabPanel value="2" sx={{ p: 0 }}>
          {value === "2" && (<AddInfluencerYT showAddInfluencer={showDetail} excelData={excelData} clearExcelData={clearExcelData} />)}
        </TabPanel>
      </TabContext>
      {showExcelUpload && <ExcelFileInput onUpload={handleExcelData} openUpload={showPopup} />}
    </section >
  );
};
